export default __webpack_public_path__ + "static/media/fw-victoria-er-Yellow Gold.756c64a1.mp4";